let routes = [
  {
    path: '/aucun-id-contact',
    name: 'NoContactId',
    component: () => import("../views/Errors/NoContactId.vue")
  },
  {
    path: '/erreur-facture-id',
    component: () => import("../views/Errors/ErreurFactureId.vue")
  },
  {
    path: '/formulaire-deja-soumis',
    component: () => import("../views/Errors/FormulaireDejaSoumis.vue")
  },
  {
    path: '/param-formulaire-introuvable/:id',
    component: () => import("../views/Errors/ParamFormulaireIntrouvable.vue"),
    props: true
  },
  {
    path: '/acces-non-autorise',
    name: 'Unauthorized',
    component: () => import("../views/Errors/Unauthorized.vue"),
    props: true
  },
  {
    path: '/erreur-interne',
    name: 'InternalError',
    component: () => import("../views/Errors/InternalError.vue"),
    props: true
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import("../views/Errors/NotFound.vue"),
    props: true
  },
  {
    path: '/renouvellement-en-cours',
    name: 'RenouvellementEnCours',
    component: () => import("../views/Errors/RenouvellementEnCours.vue"),
    props: true
  },
]

export default routes;


